module.exports = __webpack_public_path__ + "source/img/robot-blink.0824e62c.png";